import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { useAuth } from '../context';
import Loader from '../components/Loader';
import './SignUp.css';

const SignUp = () => {
     const { register } = useAuth();
    const navigate = useNavigate();

    const [form, setForm] = useState({name: '', email: '', password: '', confirmPassword: ''});
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const onChange = (e) => setForm((f) => ({...f, [e.target.name]: e.target.value}));

    const onSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (form.password !== form.confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setSubmitting(true);
        try {
            await register(form);
            navigate('/account', { replace: true });
        } catch (err) {
            setError(err.message || 'Failed to sign up.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="signup-container">
            <h2 className="signup-title">Create account</h2>
            {error && <div className="signup-error">{error}</div>}
            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <label>Name</label>
                    <input
                        type="text"
                        name="name"
                        className="form-input"
                        value={form.name}
                        onChange={onChange}
                        required
                        placeholder="Full name"
                    />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        name="email"
                        className="form-input"
                        value={form.email}
                        onChange={onChange}
                        required
                        placeholder="you@example.com"
                    />
                </div>
                <div className="form-group">
                    <label>Password</label>
                    <input
                        type="password"
                        name="password"
                        className="form-input"
                        value={form.password}
                        onChange={onChange}
                        required
                        minLength={6}
                        placeholder="At least 6 characters"
                    />
                </div>
                <div className="form-group">
                    <label>Confirm Password</label>
                    <input
                        type="password"
                        name="confirmPassword"
                        className="form-input"
                        value={form.confirmPassword}
                        onChange={onChange}
                        required
                        minLength={6}
                        placeholder="Re-enter new password"
                    />
                </div>

                <button type="submit" disabled={submitting} className="btn btn-primary signup-submit">
                    {submitting ? <Loader size="small" color="#fff" /> : 'Create account'}
                </button>
            </form>
            <div className="signup-footer">
                Already have an account? <Link to="/login">Sign in</Link>
            </div>
        </div>
    );
};

export default SignUp;
